var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-backdrop" }, [
    _c("div", { staticClass: "modal" }, [
      _c(
        "header",
        { staticClass: "modal-header" },
        [
          _vm._t("header", function() {
            return [_vm._v("\n        This is the default title!\n      ")]
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-close",
              attrs: { type: "button" },
              on: { click: _vm.close }
            },
            [_vm._v("\n        x\n      ")]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "modal-body" },
        [
          _vm._t("body", function() {
            return [_vm._v("\n        This is the default body!\n      ")]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "modal-footer" },
        [
          _vm._t("footer", function() {
            return [_vm._v("\n        This is the default footer!\n      ")]
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701ac82d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701ac82d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 